var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 41,
    viewBox: "0 0 57 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9996 6.87367C54.686 5.68077 54.0752 4.60079 53.232 3.74852C52.365 2.87005 51.3023 2.24165 50.1444 1.92265C45.8107 0.704585 28.4481 0.704585 28.4481 0.704585C21.2098 0.616768 13.9734 1.00301 6.77952 1.86113C5.62153 2.2037 4.56088 2.84614 3.69192 3.7313C2.8381 4.60732 2.21965 5.68759 1.89659 6.8712C1.12052 11.3294 0.74345 15.8562 0.770467 20.3905C0.742776 24.9207 1.11892 29.4461 1.89659 33.9098C2.21273 35.0885 2.82887 36.1639 3.685 37.0325C4.54112 37.9012 5.60725 38.5287 6.77952 38.8609C11.1709 40.0765 28.4481 40.0765 28.4481 40.0765C35.6956 40.1644 42.9413 39.7782 50.1444 38.9199C51.3023 38.6009 52.365 37.9725 53.232 37.094C54.0749 36.2419 54.685 35.1618 54.9973 33.9689C55.7936 29.5124 56.1808 24.9837 56.1534 20.4471C56.2133 15.8913 55.8266 11.3413 54.9996 6.8712V6.87367ZM22.9283 28.8161V11.9674L37.374 20.393L22.9283 28.8161Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.daf2853ed83fbce269990a501cc5886b.svg";
export { ForwardRef as ReactComponent };